import SystemMessageOption from "../model/SystemMessageOption";

export default class SystemMessage {
    constructor(title, description, options) {
        this.title = title;
        this.description = description;

        /** @type {Array<SystemMessageOption>} */
        this.options = options;
    }
}